export var DEFAULT_SLIDE_ANIMATION_DURATION = 750;
export var ACCORDION_TITLE_DISPLAY_NAME = 'Accordion.Title';
export var ACCORDION_CONTENT_DISPLAY_NAME = 'Accordion.Content';